import type React from 'react';
import { Breadcrumbs } from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import SettingStyles from '../../../SettingStyle.module.scss';
import { ClientSettingLayout } from '~/components/common/layouts/settings/ClientSettingLayout';
import { TodoTemplateList } from '~/components/common/todo_templates/TodoTemplateList';
import { PATH } from '~/pages/settings/subtypes';

export const Page: React.FC = () => (
  <DefaultV2>
    <ClientSettingLayout>
      <div className={SettingStyles.BreadcrumbsBlock}>
        <Breadcrumbs
          items={[
            { label: '案件タイプ設定', as: Link, href: PATH },
            { label: 'TODOテンプレート設定' }
          ]}
        />
      </div>
      <h2 className={SettingStyles.SettingTitle}>
        原状回復 TODOテンプレート設定
      </h2>
      <TodoTemplateList dealType="restoration" />
    </ClientSettingLayout>
  </DefaultV2>
);
